import { Button } from '@occc-app/design-system';

import { SurveyTabs } from '../constants';

export type CampaignComponentFooterActionsProps = {
  onCancel: () => void;
  onNextStepClick: () => void;
  isSubmitDisabled: boolean;
  isEntityExists: boolean;
  currentTab: SurveyTabs;
  isUserPermittedToEditSurvey: boolean;
};

export const FooterActions = ({
  onCancel,
  onNextStepClick,
  isSubmitDisabled,
  isEntityExists,
  currentTab,
  isUserPermittedToEditSurvey,
}: CampaignComponentFooterActionsProps) => {
  const saveActionTitle = isEntityExists ? 'Save changes' : 'Save Draft';
  const actionButtonTitle = currentTab !== SurveyTabs.Schedule ? 'Continue' : saveActionTitle;

  return (
    <>
      <Button onClick={onCancel}>Cancel</Button>

      {isUserPermittedToEditSurvey ? (
        <Button type='submit' color='primary' variant='contained' disabled={isSubmitDisabled}>
          {actionButtonTitle}
        </Button>
      ) : (
        <Button onClick={onNextStepClick} color='primary' variant='contained'>
          Next
        </Button>
      )}
    </>
  );
};
